'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('balance-sheet', {
      url: '/accounting/balance-sheet',
      template: '<balance-sheet></balance-sheet>'
    });
}



// WEBPACK FOOTER //
// ./client/app/accounting/balance-sheet/balance-sheet.routes.js